import React from "react";
import "./AboutUs.css";
import Footer from "../components/Footer";
const AboutUs = () => {
  return (
    <div className="about-container">
      <div className="about-us-container">
        {/* Section: Get to Know Us */}
        <section className="about-section">
          <h1 className="section-title">Get to know us</h1>
          <p className="section-content">
            We bring together a network of certified diagnostic labs, blood
            banks, medicine providers, and imaging centers, enabling patients to
            find the services they need without the hassle. Whether you’re
            looking for routine lab tests, emergency blood donations, doorstep
            medicine delivery, or high-quality imaging services, we’ve got you
            covered.
          </p>
        </section>

        {/* Section: Our Mission */}
        <section className="about-section">
          <h1 className="section-title">Our Mission</h1>
          <p className="section-content">
            At ABOMED, our mission is to simplify healthcare by providing easy
            access to essential medical services. We are committed to offering a
            comprehensive platform where patients can book lab tests, access
            blood bank services, order medicines, and find trusted diagnostic
            imaging centers—all in one place. Our goal is to empower individuals
            to take control of their health by providing reliable, affordable,
            and convenient solutions.
          </p>
        </section>

        {/* Section: Our Vision */}
        <section className="about-section">
          <h1 className="section-title">Our Vision</h1>
          <p className="section-content">
            We envision a future where healthcare is seamless, affordable, and
            accessible to everyone. Our platform is designed to support
            individuals at every stage of their healthcare journey, from
            diagnosis to treatment and beyond.
          </p>
        </section>

        {/* Section: Why Choose Us */}
        <section className="about-section">
          <h1 className="section-title">Why Choose Us?</h1>
          <ul className="why-choose-list">
            <li>
              <strong>Convenience:</strong> Access multiple healthcare services
              from one platform, at your convenience.
            </li>
            <li>
              <strong>Trustworthy:</strong> We partner with certified and
              experienced providers to ensure the highest quality services.
            </li>
            <li>
              <strong>Affordable:</strong> Compare prices for lab tests,
              medicines, and diagnostic services to get the best rates.
            </li>
            <li>
              <strong>Speed and Efficiency:</strong> Fast booking and delivery
              options for all services.
            </li>
          </ul>
        </section>

        {/* Section: Our Platform Offers */}
        <section className="about-section">
          <h1 className="section-title">Our Platform Offers</h1>
          <ul className="platform-offers-list">
            <li>
              <strong>Lab Tests:</strong> Book lab investigations from trusted
              centers with easy home sample collection options.
            </li>
            <li>
              <strong>Blood Bank Services:</strong> Find the nearest blood bank,
              check availability, and request blood donations.
            </li>
            <li>
              <strong>Medicine Delivery:</strong> Order prescription medications
              and get them delivered right to your doorstep.
            </li>
            <li>
              <strong>Diagnostic Imaging Centers:</strong> Access a wide range
              of imaging services, including CT scans, MRIs, X-rays, and more,
              at top-rated centers near you.
            </li>
          </ul>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default AboutUs;
